
const DifferentiationSection = () => {
  const points = [
    {
      title: 'Focused intelligence beats broad automation',
      description: 'Targeted solutions deliver better results than generic tools',
      icon: 'ri-focus-3-line'
    },
    {
      title: 'Systems are designed, not stitched together',
      description: 'Purpose-built architecture for seamless integration',
      icon: 'ri-layout-grid-line'
    },
    {
      title: 'Clear ownership, visibility, and accountability',
      description: 'Full transparency in every deployment and outcome',
      icon: 'ri-eye-line'
    },
  ];

  return (
    <section className="relative py-36 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c60e29162df7e66ee670b1c7301281a3.jpg"
          alt="Why This Works"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/80"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-4 block">
            OUR ADVANTAGE
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white">
            Why This Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {points.map((point, index) => (
            <div
              key={index}
              className="group bg-zinc-900/50 backdrop-blur-sm border border-emerald-500/20 rounded-2xl p-10 hover:border-emerald-500/50 hover:bg-zinc-900/80 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-500/10 rounded-xl mb-6 group-hover:bg-emerald-500/20 transition-colors">
                <i className={`${point.icon} text-emerald-400 text-2xl`}></i>
              </div>
              <h3 className="text-white text-xl font-bold mb-3 leading-snug">
                {point.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentiationSection;
